/** 운영 빌드이면서 주소가 /renewal 미리보기가 아닐 때만 색인한다. 로컬·develop·stage는 검색 대상이 아니다. */
export function renewalRobots(pathname: string) {
  const production = process.env.REACT_APP_ENV === 'production'
  const preview = pathname === '/renewal' || pathname.startsWith('/renewal/')
  if (production && !preview) return 'index,follow,max-image-preview:large'
  return 'noindex,nofollow'
}
